import { CalendarDaysIcon, CheckIcon } from '@heroicons/react/20/solid';
import EntityStatesAutoCompleteInput from 'components/form/EntityStatesAutoCompleteInput';
import FileDragAndDrop from 'components/form/FileDragAndDrop';
import Button from 'components/generic/Button';
import JSONView from 'components/generic/JSONView';
import Input from 'components/Inputs/Input';
import { inputOnChange } from "lib/utilities";
import { observer } from "mobx-react-lite";
import { FirstContactAttachmentFormValues } from 'models/FirstContactAttachment/FirstContactAttachment';
import { AttachmentFormValues, IAttachment } from 'models/generic/Attachment';
import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { RootStoreContext } from "stores/RootStore";

interface OwnProps {
  refresh: () => void
}

type Props = OwnProps;
export type FirstContactAttachmentFormProps = Props

const FirstContactAttachmentForm: FunctionComponent<Props> = ({refresh}) => {
  const rootStore = useContext(RootStoreContext);
  const {setTitleIcon, setTitle} = rootStore.commonStore;
  const {createFirstContactAttachment} = rootStore.firstContactAttachmentStore;
  const {user} = rootStore.oidcStore;
  const {closeModal} = rootStore.modalStore;

  const [currentAttachment, setCurrentAttachment] = useState(new AttachmentFormValues())
  const [lEntityState, setLEntityState, refreshLEntityState] = useLocalStorage('currentEntityState', null)
  const [lEntities, , refreshLEntities] = useLocalStorage('entityStates', null)

  // UseEffects
  useEffect(() => {
    setTitleIcon(CalendarDaysIcon)
    setTitle('First Contact Date Upload')
  }, []);

  // Functions
  const createAttachment = async (attachment: IAttachment) => {
    // @ts-ignore
    const newFirstContactAttachment: FirstContactAttachmentFormValues = {...attachment }
    await createFirstContactAttachment(newFirstContactAttachment).then(() => refresh());
  }

  const handleChange = (e) => {
    inputOnChange(e, setCurrentAttachment)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!lEntityState && refreshLEntityState) {
      // @ts-ignore
      refreshLEntityState((newEntityState) => {
        if (!newEntityState && refreshLEntities) {
          // @ts-ignore
          return refreshLEntities((newEntities) => {
            if (newEntities && setLEntityState){
              setLEntityState(newEntities[0])
              return newEntities[0]
            }
          })
        }

        return newEntityState
      })
    }

    // @ts-ignore
    let tmpAttachment = Array.isArray(lEntities) && lEntityState !== null ? {...currentAttachment, entityId: lEntityState?.entityId ?? lEntities[0].entityId}: {...currentAttachment}

    tmpAttachment.name = tmpAttachment.file.name;
    tmpAttachment.createdByName = user?.profile.email || '';

    createAttachment(tmpAttachment)
  }

  const handleFile = (files: File[]) => {
    let tmpAttachment = {...currentAttachment}
    tmpAttachment.file = files[0]
    setCurrentAttachment(tmpAttachment)
  }
  const handleAutoComplete = (value: any, name: string) => {
    handleChange({
      currentTarget: {
        name, value
      }
    })
  }

  return (
    <form autoComplete={'off'} onSubmit={handleSubmit}
      className={'overflow-y-auto overflow-x-hidden grow flex flex-col h-full'}>
      <div className={'grow h-full'}>
        <div>
          <EntityStatesAutoCompleteInput
            required
            onChange={(e) => handleAutoComplete( e.id, 'entityStateId')}
            placeholder={'California'}
          />
          <Input type="textarea"
            label={'Description'}
            value={currentAttachment.description}
            name={'description'}
            onChange={handleChange}
            maxLength={8000}
            rows={5}
            placeholder={'101 Secrets of Time Travel.pdf'}
          />
          <div className={'text-red-600'}>
            <span className={`shake ${currentAttachment.description.length < 7900 ? 'hide' : ''}`}>
              {8000 - currentAttachment.description.length} remaining characters</span>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-1 gap-x-4 gap-y-1">
          <FileDragAndDrop maxNumberOfFiles={1} acceptedFileTypes={'.xls,.xlsx'} 
            name={'file'} label={'File'} onChange={handleFile} required />
        </div>
        <JSONView data={currentAttachment}/>
      </div>

      <div className={'flex justify-end'}>
        <Button iconLeft={<CheckIcon className={'h-5 w-5'}/>} name={'save'} color={'green'}
          type={'submit'} disabled={!currentAttachment.file}>Save</Button>
        <span className={'m-2'}/>
        <Button onClick={() => closeModal('EntityModal')} color={'red'}>Cancel</Button>
      </div>

    </form>
  );
};

export default observer(FirstContactAttachmentForm)
